import { createContext, ReactNode, useContext, useState } from "react";
import './tips.css'
import CustomImage from "components/common/CustomImage";

interface TipsContextObj {
    show: (type: TipsType, msg: string) => void
}
  
const TipsContext = createContext<TipsContextObj|null>(null);

export function useTipsContext() : TipsContextObj | null{
    return useContext(TipsContext)
}

export enum TipsType {
    WARNING = 'warning',
    ERROR = 'error',
    SUCCESS = 'success'
}

export default function TipsLayout(props: { children : ReactNode}){
    const [ type, setType ] = useState<TipsType>();
    const [ msg, setMsg ] = useState<string>()
    const [ className, setClassName ]= useState<string>()

    const show = (type: TipsType, msg: string) => {
        setType(undefined);
        setTimeout(() => {
            setClassName(type)
            setType(type);
            setMsg(msg)
        }, 20)
    }

    return (
        <TipsContext.Provider value={{
            show
        }}>
            { props.children }
            {
                type ? 
                    <div className={'t ' + className}>
                        <CustomImage src={'/icon/icon-tip-' + type + '.png'} /> {msg}
                    </div>
                : null
            }
                    
            
        </TipsContext.Provider>
    )
}